module.exports = {
  API_URL: '',
  WORKSHOP_NOTIFICATION_MAX_LENGTH: 128,
  MAX_FILE_SIZE: 5e6, // maximum file size the user is allowed to pick (in bytes)
  MAX_UPLOAD_FILE_SIZE: 10e6, // maximum file size the server accepts (in bytes)
};
